import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import TimeSlotTypeChip from '@product-framework/components/TimeSlotTypeChip';
import { FormattedMessage } from 'react-intl';
import { useAvailabilitySlotTypes } from '@product-framework/components/AvailabilitySlotTypeProvider';
import { IconLibrary } from '@product-framework/index';

function DispatchNavigation({
  timeSlotFilters = [],
  setTimeSlotFilters,
  setDispatchAlternateTimeModal,
}) {
  const { slotTypes, getSlotByCode } = useAvailabilitySlotTypes();
  return (
    <Stack direction="row" spacing={2} alignContent="middle">
      <Box sx={{ alignContent: 'flex-end' }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<IconLibrary.DispatchAlternateTime />}
          onClick={() => setDispatchAlternateTimeModal(true)}>
          <FormattedMessage
            id="REQUEST_ALTERNATE_TIME"
            defaultMessage="Request Alternate Time"
          />
        </Button>
      </Box>
      <FormControl size="small" sx={{ width: 'fit-content', minWidth: 200 }}>
        <InputLabel id="dispatch-cal-slot-filter" shrink>
          <FormattedMessage
            id="FILTER_TIME_SLOT"
            defaultMessage="Time Slot filter"
          />
        </InputLabel>
        <Select
          labelId="dispatch-cal-slot-filter"
          id="dispatch-cal-slot-filter-select"
          multiple
          displayEmpty
          value={timeSlotFilters}
          sx={{
            '& .MuiSelect-select': {
              py: 0.25,
            },
          }}
          input={
            <OutlinedInput
              size="small"
              endAdornment={
                Array.isArray(timeSlotFilters) &&
                timeSlotFilters?.length > 0 && (
                  <InputAdornment
                    position="end"
                    sx={{
                      mr: 3.5, // Move left to avoid overlap with arrow
                    }}>
                    <IconButton
                      edge="end"
                      size="small"
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        setTimeSlotFilters([]);
                      }}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                )
              }
            />
          }
          onChange={e => {
            const v = e.target.value;

            setTimeSlotFilters(v);
          }}
          renderValue={selected =>
            selected
              .map(k => {
                return getSlotByCode({ code: k })?.name || '';
              })
              .join(', ')
          }
          MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}>
          {slotTypes.map(slot => (
            <MenuItem
              key={slot?.code}
              value={slot?.code}
              dense
              sx={{ gap: 0, py: 0 }}>
              <Checkbox
                size="small"
                checked={timeSlotFilters.includes(slot?.code)}
                tabIndex={-1}
                disableRipple
              />

              <TimeSlotTypeChip name={slot?.name} code={slot?.code} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
}

export default DispatchNavigation;
